export default __webpack_public_path__ + "static/media/right-icon-solid-black.f6554846.svg";